import React, { useEffect } from 'react';
import _get from 'lodash/get';
import { useData, useStatus } from 'resift';
import { useDispatch } from 'react-redux';
import SourceType from 'types/Source';
import makeGetMappingsAttributes from 'fetches/makeGetMappingsAttributes';
import useEntityTypes, { PERSON_ENTITY_TYPE_KEY } from 'helpers/useEntityTypes';

import Loader from 'components/Loader';
import TextBlock from 'components/TextBlock';
import MappingsValidationFetcher from './MappingsValidationFetcher';

interface Props {
  source: SourceType;
  setMappings: (batchActions: any[]) => void;
  setDirty: (dirty: boolean) => void;
}

function MappingsContainer({ source, setMappings, setDirty }: Props) {
  const dispatch = useDispatch();
  const entityTypes = useEntityTypes();
  const userConfig = _get(entityTypes, PERSON_ENTITY_TYPE_KEY);
  const { _fields } = userConfig;
  const getMappingsAttributes = makeGetMappingsAttributes(source.id);

  useEffect(() => {
    if (_get(source, 'authorizationStatus.isAuthorized')) {
      dispatch(getMappingsAttributes());
    }
  }, []);

  const mappingAttributes = useData(getMappingsAttributes);
  const status = useStatus(getMappingsAttributes);

  if (!_get(source, 'authorizationStatus.isAuthorized')) {
    return (
      <TextBlock>
        This source is unauthorized. <br />
        Mappings may only be changed on authorized sources.
      </TextBlock>
    );
  }

  return (
    <Loader status={status}>
      {() => (
        <MappingsValidationFetcher
          mappingAttributes={mappingAttributes}
          userFields={_fields}
          source={source}
          setMappings={setMappings}
          setDirty={setDirty}
        />
      )}
    </Loader>
  );
}

export default MappingsContainer;
